import IconBase from '@/components/IconBase.vue'
import IconForward from '@/components/icons/arrowForward.vue'
import IconCheck from '@/components/icons/check.vue'
import Globals from '@/assets/scripts/global-functions.js'
import BackButton from '@/components/BackButton.vue'
import NextButton from '@/components/forms/ButtonNext.vue'
import DOB from '@/components/forms/DateOfBirth.vue'


export default {
    name: "AboutYou",
    components: {
        IconBase,
        IconForward,
        IconCheck,
        Globals,
        BackButton,
        NextButton,
        DOB
    },
    data() {
        return {
            first_name: "",
            last_name: "",
            dictionary: {
                custom: {
                    first_name: {
                        required: () => 'First name is required to proceed',
                        max: 'Cannot exceed more than 60 characters'
                    },
                    last_name: {
                        required: () => 'Last name is required to proceed',
                        max: 'Cannot exceed more than 60 characters'
                    },
                }
            }
        }
    },
    computed: {
        AllFieldsValid: function() {
            /*
            Function:
            ► Returns boolean 
            ► Check if all entered fields are valid
            ► This computed functions is used in Next button (will highlight more if all fields are valid)
            */
            let _isvalid = false;
            if(this.fields.first_name && this.fields.last_name) {
                if(this.fields.first_name.valid && this.fields.last_name.valid) { _isvalid = true; }
            }
            return _isvalid;
        }
    },
    methods: {
        Next() {
            /*
            Function:
            ► Validates all fields via vee-validate
            ► Updates process object, current step and the session storage if all validations are valid
            ► Push through the next step if all validations are valid
            */
            this.$validator.validateAll().then((result) => {
                if(result) {
                    //this.$parent.EducatorInsuranceProcess.first_name = this.first_name;
                    //this.$parent.EducatorInsuranceProcess.last_name = this.last_name;

                    let _educator = {}
                    _educator.first_name = this.first_name;
                    _educator.last_name = this.last_name;
                    _educator.type = "full-time educator";
                    _educator.email_address = null;
                    _educator.mobile_number = null;
                    _educator.phone_number = null;
                    _educator.date_of_birth = null;
                    _educator.birth_day = null;
                    _educator.birth_year = null;
                    _educator.birth_month = null;
                    if(this.$parent.EducatorInsuranceProcess.Educators) {
                        this.$parent.EducatorInsuranceProcess.Educators[0].first_name = this.first_name;
                        this.$parent.EducatorInsuranceProcess.Educators[0].last_name = this.last_name;
                    } else {
                        this.$parent.EducatorInsuranceProcess.Educators = [];
                        this.$parent.EducatorInsuranceProcess.Educators.push(_educator);
                    }
                    this.$parent.EducatorNextStep(1,"YourAddress");
                } else {
                    console.error("There seems to be an error in your entries")
                } 
            });
        },
        ValidateSessionData() {
            /*
            Function: 
            ► Checks if there is an existing data in the session (preferrably first_name)
            ► Loads first_name and last_name into the form if there is an existing data
            */
            if(this.$parent.EducatorInsuranceProcess.Educators) {
                const _educator = this.$parent.EducatorInsuranceProcess.Educators[0];
                this.first_name = _educator.first_name;
                this.last_name = _educator.last_name;
                this.$validator.validateAll(); /* this was added to add success state on fields and buttons */
            }
        }
    },
    mounted () {
        this.$validator.localize('en', this.dictionary);
        this.$parent.CheckWindowPathName();
        this.$parent.isContinueActive = false;
        this.ValidateSessionData(); 
        this.$parent.CurrentProcess = "EducatorInsuranceProcess"; /* sets the process to educator if page loaded directly */
    }
}